module.exports = __webpack_public_path__ + "img/image-user-right.334e102d.svg";